import { OnInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { CreacionCodigos } from 'src/app/models/creacionCodigos.model';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'guardar-codigo-reutilizable',
    templateUrl: './guardar-codigo-reutilizable.component.html',
    styleUrls: ['./guardar-codigo-reutilizable.component.scss']
  })
  export class guardarCodigoReutilizableComponent implements OnInit {

    public modalOptionsTarjeta: ConfirmationModalOptions;
    public modalOptionsSticker: ConfirmationModalOptions;
    public generadorPDF: any;
    public parametroTarjetaSticker: string;
    public filtrocantidadCodigos: string;
    public filtroSede: string;
    public sede: DetalleDominio[];
    public validarTarjeta = false;
    public validarSticker = false;
    public cantidadMaxima = 0;
    public tipoCodigo: string;

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private global: GlobalService,
        private alertService: AlertService
    ) {
        this.modalOptionsTarjeta =
            new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONF_CREAR_CODIGOS_TARJETAS,
            'SI', 'NO', 'fas fa-print', true , false, 'Crear Códigos y Generar PDF tarjetas',
            null, 'btn-secondary');

        this.modalOptionsSticker =
            new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONF_CREAR_CODIGOS_STICKERS,
            'SI', 'NO', 'fas fa-edit', true, false, 'Crear Códigos', null, 'btn-secondary');
    }

    ngOnInit() {
        this.getParametroCantidadMaxima();
        this.obtenerSede();
        this.parametroTarjetaSticker = this.global.zonaCompartida[VariablesZonaCompartida.TIPO_GENRACION];
    }

    getParametroCantidadMaxima() {
        const serviceProvider = 'consultarParametros';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_TRANS);
        const lista: string[] = [ConstantesService.CANTIDAD_MAXIMA_CODIGOS_STICKERS_TARJETAS,
                                 ConstantesService.TIPO_CODIGO_STICKER];

        this.global.postGenerico(url, lista).subscribe(
            (data: any[]) => {
                if (data.length > 0) {
                    this.tipoCodigo = data.find(parametro => parametro.nombre === ConstantesService.TIPO_CODIGO_STICKER).valor;
                    this.cantidadMaxima = data.find(parametro => parametro.nombre === ConstantesService
                            .CANTIDAD_MAXIMA_CODIGOS_STICKERS_TARJETAS).valor;
                }
            }, err => {
                this.cathException('Error Consultando parametros');
            }
        );
    }

    // tslint:disable: jsdoc-format
    /**
   * Método encargado de realizar la conexion con el back y enviarle los filtros necesarios
   * para realizar el guardado para las tarjetas
   * @function getConfirmationModalTarjeta
   * @param  {type} event trae la respuesta del mensaje de confirmacion TRUE o FALSE
   * @return
   */
    getConfirmationModalTajeta(event) {
        if (event[0] === true) {
            this.crearCodigosTarjeta();
        }
    }

    /**
   * Método encargado de realizar la conexion con el back y enviarle los filtros necesarios
   * para realizar el guardado para los stickers
   * @function getConfirmationModalTarjeta
   * @param  {type} event trae la respuesta del mensaje de confirmacion TRUE o FALSE
   * @return
   */
    getConfirmationModalSticker(event) {
        if (event[0] === true) {
            this.crearCodigosSticker();
        }
    }

     /**
     * Método que regresa a administrar codigos
     * @function regresarAdministrarCodigo
     * @return
     */
  regresarAdministrarCodigo() {
    this.global.zonaCompartida[VariablesZonaCompartida.TIPO_GENRACION] = undefined;
    this.router.navigate(['/main/administrar-codigos-reutilizable']);
  }

  /**
     * Consulta los tipo de Sedes Existente
     * @function obtenerSede
     * @return
     */
    public obtenerSede() {
        this.spinner.show();
        const serviceProvider = 'ObtenerDominio';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
        this.global.getGenerico(url).subscribe(
            data => {
                this.sede = data;
                this.spinner.hide();
            }, err => {
                this.cathException('No es posible Obtener tipo Usuario');
            }
        );
    }

    /**
     * Método que permite obtener el nombre de una sede a partir de un código
     * @function obtenerNombreSede
     * @author dfranco@asesoftware.com
     * @param codigo Código de la sede
     */
    public obtenerNombreSede(codigo: string) {
        const sedes: DetalleDominio[] = this.sede.filter(s => s.detalleDominioPK.nombreDetalleDominio === codigo);
        let sede = '';
        if (sedes.length > 0) {
            sede = sedes[0].valor;
        }
        return sede;
    }

     /**
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar PDF
     * @function validacion
     * @return
     */
    validacion() {
        if (this.parametroTarjetaSticker == DominiosService.VALOR_STICKER
            && /^([0-9])+$/.test(this.filtrocantidadCodigos)
            // tslint:disable: radix
            && this.filtrocantidadCodigos !== undefined && parseInt(this.filtrocantidadCodigos) > 0) {
            this.modalOptionsSticker.disabled = false;
            this.modalOptionsTarjeta.disabled = true;
        } else if (this.parametroTarjetaSticker == DominiosService.VALOR_TARJETA
            && /^([0-9])+$/.test(this.filtrocantidadCodigos) &&
            (this.filtroSede !== undefined && this.filtroSede !== 'undefined')
            && this.filtrocantidadCodigos !== undefined && parseInt(this.filtrocantidadCodigos) > 0) {
                this.modalOptionsSticker.disabled = true;
                this.modalOptionsTarjeta.disabled = false;
        } else {
            this.modalOptionsSticker.disabled = true;
            this.modalOptionsTarjeta.disabled = true;
        }
    }

    /**
     * Método que llama el servico de guardado al back y envia los filtros de cantidad
     * y sede para crear los codigos para tarjetas
     * @function crearCodigosTarjetas
     * @return
     */
    crearCodigosTarjeta() {
        if (parseInt(this.filtrocantidadCodigos) <= this.cantidadMaxima) {
            this.spinner.show();
            const serviceProvider = 'crearCodigosTarjetas';
            const parametros: CreacionCodigos = new CreacionCodigos();
            parametros.cantidad = parseInt(this.filtrocantidadCodigos);
            parametros.codigoSede = this.filtroSede;
            parametros.nombreSede = this.obtenerNombreSede(this.filtroSede);

            const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
            this.global.postGenerico(url, parametros).subscribe(
                data => {
                    this.generadorPDF = data;
                    this.spinner.hide();
                    this.descargarArchivo();
                    this.regresarAdministrarCodigo();
                }, err => {
                    this.spinner.hide();
                    if (err.status == '500') {
                    this.cathException(err.error.message);
                    } else {
                    this.cathException('No se ha podido crear PDF de las tarjetas');
                    }
                }
            );
        } else {
            this.alertService.generateAlertError(
                'La cantidad máxima permitida de códigos a crear es: ' + this.cantidadMaxima, '');
        }
    }

    /**
     * Método que llama el servico de guardado al back y envia los filtros de cantidad
     * y sede para crear los codigos para stickers
     * @function crearCodigosStickers
     * @return
     */
    crearCodigosSticker() {
        if (parseInt(this.filtrocantidadCodigos) <= this.cantidadMaxima) {
            this.spinner.show();
            const serviceProvider = 'crearCodigosStickers';
            const parametros: CreacionCodigos = new CreacionCodigos();
            parametros.cantidad = parseInt(this.filtrocantidadCodigos);
            const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
            this.global.postGenerico(url, parametros).subscribe(
                data => {
                    this.generadorPDF = data;
                    this.spinner.hide();
                    this.alertService.generateAlertSuccess('Se crearon códigos para stickers exitosamente', '');
                    this.regresarAdministrarCodigo();
                }, er => {
                    this.spinner.hide();
                    if (er.status == '500') {
                    this.cathException(er.error.message);
                    } else {
                    this.cathException('No se ha podido crear PDF de los stickers');
                    }
                });
        } else {
            this.alertService.generateAlertError(
                'La cantidad máxima permitida de códigos a crear es: ' + this.cantidadMaxima, '');
        }
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     * @function descargarArchivo
     * @return
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.generadorPDF.nombre, this.generadorPDF.archivo);
        this.alertService.generateAlertSuccess('Se crearon códigos para tarjetas '
             +'reutilizables y se generó PDF exitosamente', '');
    }


    /**
     * Método de control de Excepciones
     * @function {function name}
     * @param  {type} error                 mensaje saliente respecto al error ocurrido
     * @return
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
